webpackJsonp([35783957827783],{

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(50);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(49);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(116);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(71);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(320);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Expando from '../components/expando'
	
	// {
	/* <section id="wines" className="content-section text-center bg-light">
	        <div>
	          <div className="container">
	            <div className="row">
	              <div className="col-lg-8 mx-auto">
	                <h2 style={{ color: 'black' }}>wines</h2>
	                <div className="row">
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal1"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/01-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	
	                    <div className="portfolio-caption">
	                      <Expando clicker={<h4>Threads</h4>}>
	                        <p className="text-muted">Illustration</p>
	                      </Expando>
	                    </div>
	                  </div>
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal2"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/02-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	                    <div className="portfolio-caption">
	                      <h4>Explore</h4>
	                      <p className="text-muted">Graphic Design</p>
	                    </div>
	                  </div>
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal3"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/03-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	                    <div className="portfolio-caption">
	                      <h4>Finish</h4>
	                      <p className="text-muted">Identity</p>
	                    </div>
	                  </div>
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal4"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/04-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	                    <div className="portfolio-caption">
	                      <h4>Lines</h4>
	                      <p className="text-muted">Branding</p>
	                    </div>
	                  </div>
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal5"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/05-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	                    <div className="portfolio-caption">
	                      <h4>Southwest</h4>
	                      <p className="text-muted">Website Design</p>
	                    </div>
	                  </div>
	                  <div className="col-md-4 col-sm-6 portfolio-item">
	                    <a
	                      className="portfolio-link"
	                      data-toggle="modal"
	                      href="#portfolioModal6"
	                    >
	                      <div className="portfolio-hover">
	                        <div className="portfolio-hover-content">
	                          <i className="fas fa-plus fa-3x" />
	                        </div>
	                      </div>
	                      <img
	                        className="img-fluid"
	                        src="img/portfolio/06-thumbnail.jpg"
	                        alt
	                      />
	                    </a>
	                    <div className="portfolio-caption">
	                      <h4>Window</h4>
	                      <p className="text-muted">Photography</p>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
	
	      <section id="reviews">
	        <div className="container">
	          <div className="row">
	            <div className="col-lg-12 text-center">
	              <h2 className="section-heading text-lowercase">reviews</h2>
	              <h3 className="section-subheading text-muted">
	                What our customers have to say about us.
	              </h3>
	            </div>
	          </div>
	          <div className="row">
	            <div className="col-lg-12">
	              <ul className="timeline">
	                <li>
	                  <div className="timeline-image">
	                    <img
	                      className="rounded-circle img-fluid"
	                      src="img/about/1.jpg"
	                      alt
	                    />
	                  </div>
	                  <div className="timeline-panel">
	                    <div className="timeline-heading">
	                      <h4>Alix Kram</h4>
	                    </div>
	                    <div className="timeline-body">
	                      <p className="text-muted">
	                        Lorem ipsum dolor sit amet, consectetur adipisicing
	                        elit. Sunt ut voluptatum eius sapiente, totam reiciendis
	                        temporibus qui quibusdam, recusandae sit vero unde, sed,
	                        incidunt et ea quo dolore laudantium consectetur!
	                      </p>
	                    </div>
	                  </div>
	                </li>
	                <li className="timeline-inverted">
	                  <div className="timeline-image">
	                    <img
	                      className="rounded-circle img-fluid"
	                      src="img/about/2.jpg"
	                      alt
	                    />
	                  </div>
	                  <div className="timeline-panel">
	                    <div className="timeline-heading">
	                      <h4>Gregg</h4>
	                    </div>
	                    <div className="timeline-body">
	                      <p className="text-muted">
	                        Lorem ipsum dolor sit amet, consectetur adipisicing
	                        elit. Sunt ut voluptatum eius sapiente, totam reiciendis
	                        temporibus qui quibusdam, recusandae sit vero unde, sed,
	                        incidunt et ea quo dolore laudantium consectetur!
	                      </p>
	                    </div>
	                  </div>
	                </li>
	                <li>
	                  <div className="timeline-image">
	                    <img
	                      className="rounded-circle img-fluid"
	                      src="img/about/3.jpg"
	                      alt
	                    />
	                  </div>
	                  <div className="timeline-panel">
	                    <div className="timeline-heading">
	                      <h4>Mindy</h4>
	                      <h4 className="subheading">Transition to Full Service</h4>
	                    </div>
	                    <div className="timeline-body">
	                      <p className="text-muted">
	                        Lorem ipsum dolor sit amet, consectetur adipisicing
	                        elit. Sunt ut voluptatum eius sapiente, totam reiciendis
	                        temporibus qui quibusdam, recusandae sit vero unde, sed,
	                        incidunt et ea quo dolore laudantium consectetur!
	                      </p>
	                    </div>
	                  </div>
	                </li>
	                <li className="timeline-inverted">
	                  <div className="timeline-image">
	                    <img
	                      className="rounded-circle img-fluid"
	                      src="img/about/4.jpg"
	                      alt
	                    />
	                  </div>
	                  <div className="timeline-panel">
	                    <div className="timeline-heading">
	                      <h4>July 2014</h4>
	                      <h4 className="subheading">Phase Two Expansion</h4>
	                    </div>
	                    <div className="timeline-body">
	                      <p className="text-muted">
	                        Lorem ipsum dolor sit amet, consectetur adipisicing
	                        elit. Sunt ut voluptatum eius sapiente, totam reiciendis
	                        temporibus qui quibusdam, recusandae sit vero unde, sed,
	                        incidunt et ea quo dolore laudantium consectetur!
	                      </p>
	                    </div>
	                  </div>
	                </li>
	                <li className="timeline-inverted">
	                  <div className="timeline-image">
	                    <h4>
	                      Be Part
	                      <br />Of Our
	                      <br />Story!
	                    </h4>
	                  </div>
	                </li>
	              </ul>
	            </div>
	          </div>
	        </div>
	      </section> */
	// }
	// {/* <section id="contact" className="content-section text-center">
	//         <div className="container">
	//           <div className="row">
	//             <div className="col-lg-8 mx-auto">
	//               <h2>Contact Start Bootstrap</h2>
	//               <p>
	//                 Feel free to leave us a comment on the
	//                 <a href="http://startbootstrap.com/template-overviews/grayscale/">
	//                   Grayscale template overview page
	//                 </a>
	//                 on Start Bootstrap to give some feedback about this theme!
	//               </p>
	//               <ul className="list-inline banner-social-buttons">
	//                 <li className="list-inline-item">
	//                   <a
	//                     href="https://twitter.com/SBootstrap"
	//                     className="btn btn-default btn-lg"
	//                   >
	//                     <i className="fa fa-twitter fa-fw" />
	//                     <span className="network-name">Twitter</span>
	//                   </a>
	//                 </li>
	//                 <li className="list-inline-item">
	//                   <a
	//                     href="https://github.com/BlackrockDigital/startbootstrap"
	//                     className="btn btn-default btn-lg"
	//                   >
	//                     <i className="fa fa-github fa-fw" />
	//                     <span className="network-name">Github</span>
	//                   </a>
	//                 </li>
	//                 <li className="list-inline-item">
	//                   <a
	//                     href="https://plus.google.com/+Startbootstrap/posts"
	//                     className="btn btn-default btn-lg"
	//                   >
	//                     <i className="fa fa-google-plus fa-fw" />
	//                     <span className="network-name">Google+</span>
	//                   </a>
	//                 </li>
	//               </ul>
	//             </div>
	//           </div>
	//         </div>
	//       </section> */}
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'header',
	        { className: 'masthead' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            right: 0,
	            zIndex: -1,
	            height: '100%'
	          },
	          sizes: data.mainImage.sizes
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'intro-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('img', {
	              src: data.logo.resize.src,
	              style: { height: '25vh', marginTop: 100 },
	              alt: 'vine and fork logo'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mx-auto' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'brand-heading ' },
	                  'vine & fork'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'intro-text' },
	                  'wine concierge service'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#about',
	                    className: 'btn btn-circle js-scroll-trigger',
	                    'aria-label': 'about'
	                  },
	                  _react2.default.createElement('i', { className: 'fa fa-angle-double-down animated' })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'about', className: 'content-section text-center' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-8 mx-auto' },
	                _react2.default.createElement(
	                  'h2',
	                  { style: { color: 'black' } },
	                  'about'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'At vine & fork we bring Sommelier selected wines directly to the hands of the consumer. Our goal is to bring boutique not commercially distributed wines to meet the everyday consumers need whether it\u2019s for personal use or a large event.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        {
	          id: 'contact',
	          className: 'download-section content-section text-center',
	          style: { position: 'relative', backgroundColor: null }
	        },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            right: 0,
	            zIndex: -1,
	            height: '100%'
	            // width: this.props.windowWidth,
	          },
	          sizes: data.secondaryImage.sizes
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'container',
	            style: {
	              textShadow: '-1px 0 #00000061, 0 1px #00000061, 1px 0 #00000061, 0 -1px #00000061',
	              fontWeight: 'bold',
	              color: 'white'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8 mx-auto' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'contact'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Follow us on instagram or reach out by email'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'list-inline banner-social-buttons' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'list-inline-item' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://www.instagram.com/vineandfork/',
	                      className: 'btn btn-default btn-lg'
	                    },
	                    _react2.default.createElement('i', { className: 'fa fa-instagram fa-fw' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'network-name' },
	                      'Instagram'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'list-inline-item' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'mailto:angelina@vineandfork.com',
	                      className: 'btn btn-default btn-lg'
	                    },
	                    _react2.default.createElement('i', { className: 'fa fa-envelope fa-fw' }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'network-name' },
	                      'Email'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2b391be7e8fdf25d9bf4.js